(function ($) {
  csPageSectionFormatterV1 = {
    formatter: $('.cs-page-section-formatter-v1')
  };

  Drupal.behaviors.csPageSectionFormatterV1 = {
    get: function (key) {
      return csPageSectionFormatterV1[key];
    },

    set: function (key, val) {
      csPageSectionFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var section = thisFormatter.find('.outer-wrap .cs-page-section');

        // Find 3rd (last) column of each row and add "col3 last" CSS classes to set its margin-right to 0
        thisFormatter.find('.outer-wrap').find('.cs-page-section-row-v1').each(function (i) {
          var row = $(this);

          row.filter(function () {
            return (i + 1) % 3 === 0;
          }).addClass('col3 last');
        });

        if (section.length) {
          section.removeClass('hidden');
        }
      });

      // Fix for PC: After user clicks the desired question, sticky nav hides cs contents and below snippet overcomes such issue.
      if (!site.client.isMobile) {
        $('.cs-page-section .section-body .query-section a').on('click', function(event) {
        // Height of the sticky nav.
          var target_scroll = $('#sticky-bar').height();
          var target = $(this).attr('href').replace('#', '');
          var target_container = $($('a[name=' + target + ']')).closest('.section-details');

          event.preventDefault();
          $('html, body').animate({ scrollTop: $(target_container).offset().top - target_scroll });
        });
      }
    }
  };
})(jQuery);
